import type { CSSProperties } from 'react';
import genbaMark from '@assets/projectMerge/genba-mark.png';
import trusstorLogo from '@assets/projectMerge/trusstor-logo.svg';
import styles from './ProvBadge.module.css';

export interface IProvBadgeProps {
  provider: 'genba' | 'trusstor';
  /** Square badge edge in px (the Trusstor wordmark badge widens past this).
      Defaults to 30 — the existing-links / unlink-modal size. */
  size?: number;
}

/**
 * Brand badge for an upstream provider — the Genba 現場 mark in a tinted square,
 * or the wide Trusstor wordmark (which overrides the square width to `auto`).
 * Extracted from the verbatim duplicate in ExistingLinks + UnlinkModal.
 *
 * NOTE: this is an internal/admin surface (the sync page names both upstreams
 * by design); it does NOT violate the "don't surface the source system to the
 * user" invariant, which governs the unified operational views.
 */
export function ProvBadge({ provider, size = 30 }: IProvBadgeProps) {
  const style = { '--badge-size': `${size}px` } as CSSProperties;
  if (provider === 'genba') {
    return (
      <span className={`${styles.badge} ${styles.badgeGenba}`} style={style}>
        <img src={genbaMark} alt="" />
      </span>
    );
  }
  return (
    <span className={`${styles.badge} ${styles.badgeTrusstor}`} style={style}>
      <img src={trusstorLogo} alt="" />
    </span>
  );
}
